import { BehaviorSubject } from 'rxjs';

export const behaviorSubjectWellnessObjectBehavior$ = new BehaviorSubject({});

export const behaviorSubjectWellnessObjectBehavior = behaviorSubjectWellnessObjectBehavior$.asObservable();
